module.exports = __webpack_public_path__ + "static/media/liftingMethod1.4d9e0e50.png";